export default "__VITE_ASSET__BeBkKi1A__"